/**
 * 教科情報定義
 */
export class Subjects {
  // 国語
  static readonly JAPANESE: SubjectMaster = {
    code: 'ko',
    name: '国語',
    managerChartLabelColor: '#c1b6ff',
  }
  // 算数/数学
  static readonly MATH: SubjectMaster = {
    code: 'su',
    name: '算数/数学',
    managerChartLabelColor: '#ffb26a',
  }
  // 英語
  static readonly ENGLISH: SubjectMaster = {
    code: 'ei',
    name: '英語',
    managerChartLabelColor: '#fb8c8c',
  }
  // 理科
  static readonly SCIENCE: SubjectMaster = {
    code: 'ri',
    name: '理科',
    managerChartLabelColor: '#7affd7',
  }
  // 社会
  static readonly SOCIAL: SubjectMaster = {
    code: 'sy',
    name: '社会',
    managerChartLabelColor: '#a4e6eb',
  }
  // 教科一覧
  static readonly LIST = [Subjects.JAPANESE, Subjects.MATH, Subjects.ENGLISH, Subjects.SCIENCE, Subjects.SOCIAL]

  // コードで取得
  static findByCode(code: string): SubjectMaster | undefined {
    return Subjects.LIST.find((subject) => {
      return subject.code === code
    })
  }
}

/**
 * 教科のマスタ定義用
 */
export type SubjectMaster = {
  // 教科コード
  code: string
  // 教科名
  name: string
  // 管理系レーダーチャートのラベルに表示する色（chart.jsに引き渡すパラメータなのでcssからは読み込めない）
  managerChartLabelColor: string
}
